// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Report.css */

.report-page {
  max-width: 900px;
  margin: 0 auto;
  padding-bottom: 2rem;
  min-width: 0;
  overflow-x: hidden;         /* sicurezza: mai scroll orizzontale a livello pagina */
}
.report-page h2 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #111827;
  margin: 0 0 1.25rem;
}

/* ── Filtri ── */
.report-filtri {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0.9rem;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  margin-bottom: 1.25rem;
  min-width: 0;
}
.report-filter-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.report-filter-title {
  font-size: 0.85rem;
  font-weight: 700;
  color: #374151;
}
.report-filter-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.6rem;
  min-width: 0;
}
.report-filter {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.75rem;
  color: #6b7280;
  font-weight: 600;
  min-width: 0;               /* evita overflow: il contenuto non può forzare la larghezza */
}
.report-filter-label {
  font-size: 0.72rem;
  font-weight: 600;
  color: #6b7280;
}

.report-filter input,
.report-filter select {
  padding: 0.55rem 0.6rem;
  border: 2px solid #e5e7eb;
  border-radius: 0.5rem;
  font-size: 0.9rem;
  font-family: inherit;
  background: #fff;
  color: #111827;
  outline: none;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
}
.report-filter input:focus,
.report-filter select:focus {
  border-color: #4f46e5;
}
.report-reset {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.4rem 0.7rem;
  border: none; border-radius: 0.375rem;
  background: var(--gray-100, #f3f4f6); color: var(--gray-600, #4b5563);
  cursor: pointer; font-size: 0.8rem; font-family: inherit; font-weight: 600;
  transition: background 150ms;
}
.report-reset:hover { background: var(--gray-200, #e5e7eb); }
.report-reset svg { flex-shrink: 0; }

.report-message {
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  font-size: 0.9rem;
}
.report-message.error { background: #fef2f2; color: #dc2626; border: 1px solid #fecaca; }
.report-loading { color: #6b7280; }

/* ── Cards riassuntive ── */
.report-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
  margin-bottom: 1.25rem;
}
.report-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}
.report-card-label { font-size: 0.78rem; color: #6b7280; font-weight: 600; }
.report-card-value { font-size: 1.15rem; font-weight: 700; }
.report-card-value.expense { color: #dc2626; }
.report-card-value.income { color: #059669; }

/* ── Card grafici ── */
.report-charts-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1rem;
  min-width: 0;
}
.report-chart-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  padding: 1.1rem;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;           /* contiene grafici/legende dentro la card */
}
.report-chart-full { margin-bottom: 1rem; }
.report-chart-card h3 {
  font-size: 0.95rem;
  font-weight: 700;
  color: #111827;
  margin: 0 0 0.9rem;
}

/* ── Donut ── */
.report-donut {
  position: relative;
  margin: 0 auto 0.75rem;
}
.report-donut-center {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.report-donut-total {
  font-size: 0.85rem;
  font-weight: 700;
  color: #374151;
}
.report-donut-empty {
  position: relative;
  margin: 0 auto 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.report-empty-label {
  position: absolute;
  font-size: 0.8rem;
  color: #9ca3af;
}
.report-empty { color: #9ca3af; font-size: 0.9rem; }

/* ── Legenda ── */
.report-legend {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  max-height: 260px;
  overflow-y: auto;
}
.report-legend-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  color: #374151;
  min-width: 0;
}
.report-legend-dot {
  width: 12px;
  height: 12px;
  border-radius: 3px;
  flex-shrink: 0;
  display: inline-block;
}
.report-legend-name {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.report-legend-value { font-weight: 600; color: #111827; white-space: nowrap; flex-shrink: 0; }
.report-legend-pct {
  min-width: 44px;
  text-align: right;
  font-weight: 700;
  color: #6b7280;
  background: #f3f4f6;
  padding: 0.1rem 0.4rem;
  border-radius: 999px;
  font-size: 0.78rem;
  flex-shrink: 0;
}

/* ── Barre mensili ── */
.report-bars {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.5rem;
  padding-top: 0.5rem;
  overflow-x: auto;
}
.report-bar-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1;
  min-width: 34px;
}
.report-bar-track {
  display: flex;
  align-items: flex-end;
  gap: 3px;
  height: 140px;
  width: 100%;
}
.report-bar {
  flex: 1 1;
  border-radius: 4px 4px 0 0;
  min-height: 2px;
}
.report-bar-spese { background: #ef4444; }
.report-bar-entrate { background: #10b981; }
.report-bar-label {
  margin-top: 0.35rem;
  font-size: 0.72rem;
  color: #6b7280;
  font-weight: 600;
}
.report-bars-legend {
  display: flex;
  flex-basis: 100%;
  gap: 1rem;
  justify-content: center;
  font-size: 0.8rem;
  color: #374151;
  margin-top: 0.5rem;
  min-width: 0;
}
.report-bars-legend span { display: flex; align-items: center; gap: 0.35rem; min-width: 0; }

/* ── Barre orizzontali portafogli ── */
.report-hbars { display: flex; flex-direction: column; gap: 0.6rem; }
.report-hbar-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.82rem;
  min-width: 0;
}
.report-hbar-name {
  width: 110px;
  max-width: 32%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
  color: #374151;
  flex-shrink: 1;
}
.report-hbar-track {
  flex: 1 1 auto;
  min-width: 0;
  height: 14px;
  background: #f3f4f6;
  border-radius: 999px;
  overflow: hidden;
}
.report-hbar { height: 100%; border-radius: 999px; min-width: 2px; }
.report-hbar-spese { background: #ef4444; }
.report-hbar-entrate { background: #10b981; }
.report-hbar-val {
  width: auto;
  min-width: 3.5em;
  text-align: right;
  font-weight: 700;
  font-size: 0.78rem;
  flex-shrink: 0;
  white-space: nowrap;
}
.report-hbar-val.spese { color: #dc2626; }
.report-hbar-val.entrate { color: #059669; }

/* ── Mobile ── */
@media (max-width: 767px) {
  .report-page { max-width: 100%; }
  .report-page h2 { font-size: 1.25rem; }
  .report-cards { grid-template-columns: 1fr; }
  .report-charts-row { grid-template-columns: 1fr; }
  .report-filter-grid { grid-template-columns: repeat(2, 1fr); }
  .report-hbar-name { width: 76px; max-width: 30%; }
  .report-hbar-val { min-width: 3em; font-size: 0.72rem; }
  .report-hbar-row { gap: 0.35rem; }
  .report-bars { min-width: 0; }
}

/* ── Schermi molto piccoli (≤ 380px) ── */
@media (max-width: 379px) {
  .report-filter-grid { grid-template-columns: 1fr; }
  .report-donut { transform: scale(0.92); }
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboard/Report.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,kBAAkB,UAAU,uDAAuD;AACrF;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,YAAY,gBAAgB,8DAA8D;AAC5F;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,YAAY,EAAE,uBAAuB;EACrC,oCAAoC,EAAE,+BAA+B;EACrE,eAAe,EAAE,iBAAiB,EAAE,oBAAoB,EAAE,gBAAgB;EAC1E,4BAA4B;AAC9B;AACA,sBAAsB,oCAAoC,EAAE;AAC5D,oBAAoB,cAAc,EAAE;;AAEpC;EACE,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;AACA,wBAAwB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AACxF,kBAAkB,cAAc,EAAE;;AAElC,4BAA4B;AAC5B;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA,qBAAqB,kBAAkB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAC3E,qBAAqB,kBAAkB,EAAE,gBAAgB,EAAE;AAC3D,6BAA6B,cAAc,EAAE;AAC7C,4BAA4B,cAAc,EAAE;;AAE5C,uBAAuB;AACvB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,gBAAgB,YAAY,4CAA4C;AAC1E;AACA,qBAAqB,mBAAmB,EAAE;AAC1C;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA,gBAAgB,cAAc,EAAE,iBAAiB,EAAE;;AAEnD,kBAAkB;AAClB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA,uBAAuB,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAC9F;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAO;EACP,eAAe;AACjB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,aAAa;EACb,WAAW;AACb;AACA;EACE,SAAO;EACP,0BAA0B;EAC1B,eAAe;AACjB;AACA,oBAAoB,mBAAmB,EAAE;AACzC,sBAAsB,mBAAmB,EAAE;AAC3C;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;AACA,2BAA2B,aAAa,EAAE,mBAAmB,EAAE,YAAY,EAAE,YAAY,EAAE;;AAE3F,uCAAuC;AACvC,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,WAAW,EAAE;AACpE;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;AACA,eAAe,YAAY,EAAE,oBAAoB,EAAE,cAAc,EAAE;AACnE,qBAAqB,mBAAmB,EAAE;AAC1C,uBAAuB,mBAAmB,EAAE;AAC5C;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;AACA,yBAAyB,cAAc,EAAE;AACzC,2BAA2B,cAAc,EAAE;;AAE3C,iBAAiB;AACjB;EACE,eAAe,eAAe,EAAE;EAChC,kBAAkB,kBAAkB,EAAE;EACtC,gBAAgB,0BAA0B,EAAE;EAC5C,qBAAqB,0BAA0B,EAAE;EACjD,sBAAsB,qCAAqC,EAAE;EAC7D,oBAAoB,WAAW,EAAE,cAAc,EAAE;EACjD,mBAAmB,cAAc,EAAE,kBAAkB,EAAE;EACvD,mBAAmB,YAAY,EAAE;EACjC,eAAe,YAAY,EAAE;AAC/B;;AAEA,0CAA0C;AAC1C;EACE,sBAAsB,0BAA0B,EAAE;EAClD,gBAAgB,sBAAsB,EAAE;AAC1C","sourcesContent":["/* Report.css */\n\n.report-page {\n  max-width: 900px;\n  margin: 0 auto;\n  padding-bottom: 2rem;\n  min-width: 0;\n  overflow-x: hidden;         /* sicurezza: mai scroll orizzontale a livello pagina */\n}\n.report-page h2 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #111827;\n  margin: 0 0 1.25rem;\n}\n\n/* ── Filtri ── */\n.report-filtri {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  padding: 0.9rem;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.75rem;\n  margin-bottom: 1.25rem;\n  min-width: 0;\n}\n.report-filter-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.report-filter-title {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: #374151;\n}\n.report-filter-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.6rem;\n  min-width: 0;\n}\n.report-filter {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  font-size: 0.75rem;\n  color: #6b7280;\n  font-weight: 600;\n  min-width: 0;               /* evita overflow: il contenuto non può forzare la larghezza */\n}\n.report-filter-label {\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: #6b7280;\n}\n\n.report-filter input,\n.report-filter select {\n  padding: 0.55rem 0.6rem;\n  border: 2px solid #e5e7eb;\n  border-radius: 0.5rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  background: #fff;\n  color: #111827;\n  outline: none;\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n.report-filter input:focus,\n.report-filter select:focus {\n  border-color: #4f46e5;\n}\n.report-reset {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.4rem 0.7rem;\n  border: none; border-radius: 0.375rem;\n  background: var(--gray-100, #f3f4f6); color: var(--gray-600, #4b5563);\n  cursor: pointer; font-size: 0.8rem; font-family: inherit; font-weight: 600;\n  transition: background 150ms;\n}\n.report-reset:hover { background: var(--gray-200, #e5e7eb); }\n.report-reset svg { flex-shrink: 0; }\n\n.report-message {\n  padding: 0.75rem 1rem;\n  border-radius: 0.5rem;\n  margin-bottom: 1rem;\n  font-size: 0.9rem;\n}\n.report-message.error { background: #fef2f2; color: #dc2626; border: 1px solid #fecaca; }\n.report-loading { color: #6b7280; }\n\n/* ── Cards riassuntive ── */\n.report-cards {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.75rem;\n  margin-bottom: 1.25rem;\n}\n.report-card {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.75rem;\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n.report-card-label { font-size: 0.78rem; color: #6b7280; font-weight: 600; }\n.report-card-value { font-size: 1.15rem; font-weight: 700; }\n.report-card-value.expense { color: #dc2626; }\n.report-card-value.income { color: #059669; }\n\n/* ── Card grafici ── */\n.report-charts-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  min-width: 0;\n}\n.report-chart-card {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.75rem;\n  padding: 1.1rem;\n  min-width: 0;\n  max-width: 100%;\n  overflow: hidden;           /* contiene grafici/legende dentro la card */\n}\n.report-chart-full { margin-bottom: 1rem; }\n.report-chart-card h3 {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #111827;\n  margin: 0 0 0.9rem;\n}\n\n/* ── Donut ── */\n.report-donut {\n  position: relative;\n  margin: 0 auto 0.75rem;\n}\n.report-donut-center {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n}\n.report-donut-total {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: #374151;\n}\n.report-donut-empty {\n  position: relative;\n  margin: 0 auto 0.75rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.report-empty-label {\n  position: absolute;\n  font-size: 0.8rem;\n  color: #9ca3af;\n}\n.report-empty { color: #9ca3af; font-size: 0.9rem; }\n\n/* ── Legenda ── */\n.report-legend {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  max-height: 260px;\n  overflow-y: auto;\n}\n.report-legend-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.85rem;\n  color: #374151;\n  min-width: 0;\n}\n.report-legend-dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 3px;\n  flex-shrink: 0;\n  display: inline-block;\n}\n.report-legend-name {\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.report-legend-value { font-weight: 600; color: #111827; white-space: nowrap; flex-shrink: 0; }\n.report-legend-pct {\n  min-width: 44px;\n  text-align: right;\n  font-weight: 700;\n  color: #6b7280;\n  background: #f3f4f6;\n  padding: 0.1rem 0.4rem;\n  border-radius: 999px;\n  font-size: 0.78rem;\n  flex-shrink: 0;\n}\n\n/* ── Barre mensili ── */\n.report-bars {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 0.5rem;\n  padding-top: 0.5rem;\n  overflow-x: auto;\n}\n.report-bar-col {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n  min-width: 34px;\n}\n.report-bar-track {\n  display: flex;\n  align-items: flex-end;\n  gap: 3px;\n  height: 140px;\n  width: 100%;\n}\n.report-bar {\n  flex: 1;\n  border-radius: 4px 4px 0 0;\n  min-height: 2px;\n}\n.report-bar-spese { background: #ef4444; }\n.report-bar-entrate { background: #10b981; }\n.report-bar-label {\n  margin-top: 0.35rem;\n  font-size: 0.72rem;\n  color: #6b7280;\n  font-weight: 600;\n}\n.report-bars-legend {\n  display: flex;\n  flex-basis: 100%;\n  gap: 1rem;\n  justify-content: center;\n  font-size: 0.8rem;\n  color: #374151;\n  margin-top: 0.5rem;\n  min-width: 0;\n}\n.report-bars-legend span { display: flex; align-items: center; gap: 0.35rem; min-width: 0; }\n\n/* ── Barre orizzontali portafogli ── */\n.report-hbars { display: flex; flex-direction: column; gap: 0.6rem; }\n.report-hbar-row {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.82rem;\n  min-width: 0;\n}\n.report-hbar-name {\n  width: 110px;\n  max-width: 32%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 600;\n  color: #374151;\n  flex-shrink: 1;\n}\n.report-hbar-track {\n  flex: 1 1 auto;\n  min-width: 0;\n  height: 14px;\n  background: #f3f4f6;\n  border-radius: 999px;\n  overflow: hidden;\n}\n.report-hbar { height: 100%; border-radius: 999px; min-width: 2px; }\n.report-hbar-spese { background: #ef4444; }\n.report-hbar-entrate { background: #10b981; }\n.report-hbar-val {\n  width: auto;\n  min-width: 3.5em;\n  text-align: right;\n  font-weight: 700;\n  font-size: 0.78rem;\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n.report-hbar-val.spese { color: #dc2626; }\n.report-hbar-val.entrate { color: #059669; }\n\n/* ── Mobile ── */\n@media (max-width: 767px) {\n  .report-page { max-width: 100%; }\n  .report-page h2 { font-size: 1.25rem; }\n  .report-cards { grid-template-columns: 1fr; }\n  .report-charts-row { grid-template-columns: 1fr; }\n  .report-filter-grid { grid-template-columns: repeat(2, 1fr); }\n  .report-hbar-name { width: 76px; max-width: 30%; }\n  .report-hbar-val { min-width: 3em; font-size: 0.72rem; }\n  .report-hbar-row { gap: 0.35rem; }\n  .report-bars { min-width: 0; }\n}\n\n/* ── Schermi molto piccoli (≤ 380px) ── */\n@media (max-width: 379px) {\n  .report-filter-grid { grid-template-columns: 1fr; }\n  .report-donut { transform: scale(0.92); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
